import { report_history_video_alertService } from '../_services';

const state = { onRequest: false, report_history_video_alert: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_history_video_alertService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_history_video_alert: state => {
    return state.report_history_video_alert
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_history_video_alert = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_history_video_alert = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_history_video_alert = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_history_video_alerts = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
